import * as React from 'react'
import { cn } from '@/lib/utils'

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = 'text', ...props }, ref) => {
    return (
      <input
        ref={ref}
        type={type}
        className={cn(
          'flex h-12 w-full rounded-md border border-input bg-background px-3 py-1 text-sm text-foreground shadow-sm outline-none',
          'placeholder:opacity-60 focus:ring-2 focus:ring-ring',
          className,
        )}
        {...props}
      />
    )
  },
)
Input.displayName = 'Input'
